import { AiProgressBar } from '@copilot/common/components/ai/aiProgressBar/aiProgressBar';

interface ReplyPredictionProps {
    /**
     * How likely the prospect will response in percentage
     */
    percent: number;
}

/**
 * [Presentation] Component to display on how likely the prospect will response
 * @param percent
 * @constructor
 */
export function ReplyPrediction({ percent }: ReplyPredictionProps) {
    return <AiProgressBar percent={percent} />;
}
